import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row,
  Input,FormText
} from "reactstrap";

import DateSelector from "../utils/dateSelector";

const SearchPanel = ({
    onSearch,
    flightDate,
    flightDateChange,
    ticketNumber,
    ticketNumberChange,
    contentErrorText
  }) => {
    return (
      <Form onSubmit={(e) => e.preventDefault()}>
        <Container>
          <Row className="align-items-end">
            <Col xs="12" sm="4" md="3" className="mb-3 mb-sm-0">
              <FormGroup className="mb-0">
                <Label>Flight Date</Label>
                <DateSelector
                  maxDate={new Date()}
                  todayDate={new Date().toString()}
                  name="flightDate"
                  selectedDate={flightDate}
                  onValueChange={flightDateChange}
                />
              </FormGroup>
            </Col>
  
            <Col xs="12" sm="5" md="6" className="mb-3 mb-sm-0">
              <FormGroup className="mb-0">
                <Label>Ticket Number</Label>
                <span style={{color:'red'}}>{contentErrorText}</span>

                <Input
                  type="text"
                  placeholder="Enter ticket number"
                  value={ticketNumber || ""}
                  onChange={(event) => ticketNumberChange(event.target.value)}
                />
              </FormGroup>
            </Col>
  
            <Col xs="12" sm="3" md="3" className={"mb-1"}>
              <Button className="btn-avi-primary w-100" onClick={() => onSearch()}>
                Search
              </Button>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  };

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/ticket-search/search-panel.js